import React, { Component } from 'react';
import Overview from './overview/overview';
import { ProjectLoader } from '$common/loaders';

export default class Layout extends Component {
  
  render() {
    const { project, activityMap } = this.props;

    return project ? (
      <Overview project={project} activityMap={activityMap} />
    ) : <ProjectLoader />
  }
}



// WEBPACK FOOTER //
// ./src/components/project/show/show.js